import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import FullBodyContentView from '../../views/fullBodyContentView';

function AlertHistory({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit});
    });
  }, [onExit]);
  return (
    <FullBodyContentView
      title="Alert History"
      fullCaption="None...............................0................ 
      [STR AlertHistTime.........0................
      None...............................0................
      [STR AlertHistTime.........0................
      None...............................0................
      [STR AlertHistTime.........0................
      None...............................0................
      [STR AlertHistTime.........0................
      None...............................0................
      [STR AlertHistTime.........0................
      None...............................0................
      "
    />
  );
}

export default AlertHistory;
